const data = {
  locations: [
    {
      coordinates: [26.229223, -98.37545],
      waitTimeDays: 0,
      countryCode: "US",
      state: "TX",
      name: "Hidalgo Enrollment Center",
      urlString: "hidalgo-enrollment-center",
      id: "5001",
      city: "Mission",
      postalCode: "78572",
      shortName: "Hidalgo Enrollment Center",
    },
    {
      waitTimeDays: 205,
      city: "San Diego",
      countryCode: "US",
      shortName: "San Diego -Otay Mesa Enrollment Center",
      coordinates: [32.557022, -117.006214],
      postalCode: "92154",
      state: "CA",
      name: "San Diego -Otay Mesa Enrollment Center",
      id: "5002",
      urlString: "san-diego-otay-mesa-enrollment-center",
    },
    {
      id: "5003",
      state: "TX",
      urlString: "brownsville-enrollment-center",
      city: "Brownsville",
      shortName: "Brownsville Enrollment Center",
      postalCode: "78521",
      waitTimeDays: 36,
      countryCode: "US",
      name: "Brownsville Enrollment Center",
      coordinates: [25.943923, -97.317944],
    },
    {
      state: "TX",
      postalCode: "780443130",
      countryCode: "US",
      shortName: "Laredo Enrollment Center",
      waitTimeDays: 0,
      id: "5004",
      city: "Laredo",
      name: "Laredo Enrollment Center",
      urlString: "laredo-enrollment-center",
    },
    {
      shortName: "El Paso Enrollment Center",
      id: "5005",
      countryCode: "US",
      postalCode: "79907",
      state: "TX",
      coordinates: [31.707231, -106.326563],
      name: "El Paso Enrollment Center",
      urlString: "el-paso-enrollment-center",
      waitTimeDays: 135,
      city: "El Paso",
    },
    {
      state: "CA",
      id: "5006",
      urlString: "calexico-enrollment-center",
      countryCode: "US",
      coordinates: [32.687552, -115.541028],
      name: "Calexico Enrollment Center",
      waitTimeDays: 170,
      shortName: "Calexico Enrollment Center",
      city: "Calexico",
      postalCode: "92231",
    },
    {
      city: "NOGALES",
      coordinates: [31.387978, -110.912001],
      name: "Nogales, AZ",
      state: "AZ",
      waitTimeDays: 35,
      shortName: "Nogales Enrollment Center",
      countryCode: "US",
      postalCode: "85621",
      id: "5007",
      urlString: "nogales-az",
    },
    {
      id: "5460",
      shortName: "San Luis Enrollment Center",
      countryCode: "US",
      postalCode: "85349",
      urlString: "san-luis-enrollment-center",
      name: "San Luis Enrollment Center",
      waitTimeDays: 231,
      city: "San Luis",
      coordinates: [32.508824, -114.743975],
      state: "AZ",
    },
    {
      shortName: "Phoenix Sky Harbor Global Entry Enrollment Center",
      countryCode: "US",
      id: "7160",
      waitTimeDays: 161,
      state: "AZ",
      postalCode: "85034",
      coordinates: [33.42958, -112.014097],
      city: "Phoenix",
      urlString: "phoenix-sky-harbor-global-entry-enrollment-center",
      name: "Phoenix Sky Harbor Global Entry Enrollment Center",
    },
    {
      countryCode: "US",
      shortName: "Albuquerque Enrollment Center",
      urlString: "albuquerque-enrollment-center",
      name: "Albuquerque Enrollment Center",
      postalCode: "87106",
      city: "Albuquerque",
      coordinates: [35.057863, -106.620735],
      id: "8040",
      waitTimeDays: 43,
      state: "NM",
    },
    {
      waitTimeDays: 29,
      countryCode: "US",
      id: "8100",
      city: "Douglas",
      name: "Douglas Enrollment Center",
      postalCode: "85607",
      coordinates: [31.520779, -109.37922],
      shortName: "Douglas Enrollment Center",
      state: "AZ",
      urlString: "douglas-enrollment-center",
    },
    {
      countryCode: "US",
      id: "9240",
      name: "Tucson Enrollment Center",
      waitTimeDays: 105,
      coordinates: [32.079259, -110.898921],
      postalCode: "85756",
      state: "AZ",
      urlString: "tucson-enrollment-center",
      city: "Tucson",
      shortName: "Tucson Enrollment Center",
    },
    {
      id: "16226",
      shortName: "Eagle Pass Enrollment Center",
      urlString: "eagle-pass",
      postalCode: "78852",
      coordinates: [28.729787, -100.316678],
      countryCode: "US",
      city: "Eagle Pass",
      state: "TX",
      waitTimeDays: 2,
      name: "Eagle Pass ",
    },
    {
      countryCode: "US",
      state: "TX",
      name: "Del Rio Port of Entry, TX 2302",
      urlString: "del-rio-port-of-entry-tx-2302",
      city: " Del Rio",
      postalCode: "78840",
      coordinates: [29.729903, -100.881337],
      waitTimeDays: 34,
      id: "16460",
      shortName: "Del Rio",
    },
  ],
  updatedAt: "2022-02-22T01:10:09Z",
};
export default data;
